<div class="forbidden-info-container" *ngIf="model">
  <div class="flex-host">
    <input class="form-text-field border-right-sharp-edge" value="{{ infoMessage }}" disabled />
    <button
      *ngIf="model.forbiddenCausingRule && userSettings.supportMode"
      mat-button
      (click)="$event.stopPropagation(); ruleShown = !ruleShown"
      class="forbidden-info-button">
      <mat-icon>visibility</mat-icon>
    </button>
  </div>

  <div class="rule-dropdown">
    <div class="side-spacer"></div>
    <div *ngIf="ruleShown && userSettings.supportMode" class="rule-wrapper">
      <p *ngIf="!isRS" class="rule-note">
        Die Gültigkeit des Formulars wird in Regeln ausgedrückt, welche in der EForms Expression
        Language (EFX) verfasst sind. Die Felder innerhalb der Regel sind mit ihrer technischen
        Bezeichnung (Business-Terms, z.b. BT-131(d)-Lot) zu finden. Das entsprechende Feld kann über
        diese Bezeichnung mithilfe der Suchfunktion gefunden werden. Es kann aus technischen Gründen
        immer nur eine Regel angezeigt werden.
        <br /><span>Diese Funktion ist Teil des Support-Modus. Es wird kein Hilfe oder Erklärung hierfür geleistet.</span>
        <br />Das Zutreffen der folgenden Regel verbietet es,
        mit dem Feld zu interagieren:
      </p>
      <p *ngIf="isRS" class="rule-note">
        Die Gültigkeit des Formulars wird in Regeln ausgedrückt, welche in der EForms Expression
        Language (EFX) verfasst sind. Die Felder innerhalb der Regel sind mit ihrer technischen
        Bezeichnung (Business-Terms, z.b. BT-131(d)-Lot) zu finden. Das entsprechende Feld kann über
        diese Bezeichnung mithilfe der Suchfunktion gefunden werden. Es kann aus technischen Gründen
        immer nur eine Regel angezeigt werden.
        <br />Das Zutreffen der folgenden Regel verbietet es,
        mit dem Feld zu interagieren:
      </p>
      <p class="rule" [ngClass]="isRS ? 'rule-rs' : ''">{{ model.forbiddenCausingRule }}</p>
    </div>
  </div>
</div>
